import React, {
  useEffect, useCallback, useState, useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BsFilterLeft } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';

import { getCompaniesAction } from '../../../actions/companyActions';
import { GET_COMPANY } from '../../../actions/types';

import { Button } from '../../../lib/HooksFormFields';
import SortButton from '../../../lib/SortButton';

import CompanyRow from '../../../components/Companies/CompanyRow/CompanyRow';
import CompaniesFilters from '../../../components/Companies/CompaniesFilters/CompaniesFilters';

import styles from './CompaniesList.module.scss';

export default function CompaniesList() {
  const { companiesList, filters, lists } = useSelector((state) => state.companies);

  const dispatch = useDispatch();
  const history = useHistory();

  const initSortState = {
    name: true,
    type: true,
  };

  const containerRef = useRef(null);

  const [sortByReverse, setSortByReverse] = useState(initSortState);
  const [filteredList, setFilteredList] = useState([]);

  const [filterIsActive, setFilterIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const getData = useCallback(() => {
    getCompaniesAction(dispatch);
    dispatch({
      type: GET_COMPANY,
      payload: null,
    });
  }, [dispatch]);

  function sortList(type, isReverse) {
    let list = filteredList;
    switch (type) {
      case 'name':
        list = list.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
        setFilteredList(isReverse ? list.reverse() : list);
        break;
      case 'type':
        list = list.sort((a, b) => {
          if (a?.type < b?.type) return -1;
          if (a?.type > b?.type) return 1;
          return 0;
        });
        setFilteredList(isReverse ? list.reverse() : list);
        break;
      default:
        break;
    }
    setSortByReverse({ ...initSortState, [type]: isReverse });
  }

  function countFilters() {
    let val = 0;
    if (filters.search) {
      val += 1;
    }
    if (filters?.type?.length) {
      val += filters?.type?.length;
    }
    return val;
  }

  useEffect(() => {
    setIsLoading(true);
    getData();
  }, []);

  useEffect(() => {
    setIsLoading(false);
    let list = companiesList;
    if (filters.search) {
      list = list.filter((p) => {
        if (p.name.toLowerCase().includes(filters.search.toLowerCase())) {
          return p;
        }
        return null;
      });
    }
    setFilteredList(list);
  }, [companiesList, filters]);

  return (
    <div className={styles.container}>
      <div className={`${styles.content} ${filterIsActive ? styles['filter-is-active'] : ''}`}>
        <header>
          <h2>CONCURRENTS</h2>
          <div className={styles['btn-container']}>
            <Button handleClick={() => history.push('/company/create')}>
              NOUVEAU CONCURRENT
            </Button>
            <Button
              handleClick={() => setFilterIsActive(!filterIsActive)}
              className={styles.filter}>
              <BsFilterLeft size={30} color={'#FFFFFF'}/> <p>{countFilters()}</p>
            </Button>
          </div>
        </header>
        <div className={styles.sort}>
          <div className={`${styles.row} ${styles.labels}`}>
            <SortButton
              name={'Nom'}
              handleClick={() => sortList('name', !sortByReverse.name)}
              state={sortByReverse.name}
              className={`${styles.col}`}/>
            <SortButton
              name={'Type'}
              handleClick={() => sortList('type', !sortByReverse.type)}
              state={sortByReverse.type}
              className={`${styles.col}`}/>
            <div className={`${styles.edit} ${styles.desktop}`}>
            </div>
          </div>
        </div>
        <div
          ref={containerRef}
          className={styles.list}
          >
          {!isLoading && filteredList.length > 0 && filteredList?.map((p, i) => <CompanyRow
            key={p._id}
            company={p}
            types={lists.types}
            index={i}
            styles={styles}
          />)}
        </div>
      </div>
      <CompaniesFilters
        isActive={filterIsActive}
        close={() => setFilterIsActive(false)}
      />
    </div>
  );
}
